<template>
  <div>
    <div class="panel mt-20">
      <div class="filter">
        <el-form
          :model="filter"
          ref="filterForm"
          label-position="left"
          @submit.native.prevent
        >
          <el-form-item label="关键字" prop="number" label-width="90px">
            <el-input
              size="small"
              v-model="filter.query"
              @keyup.enter.native="requestProductPromotions"
              placeholder="产品描述或件号"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item label="状态" prop="number" label-width="40px">
            <el-select
              v-model="filter.status"
              size="small"
              placeholder="请选择"
              style="width: 100%"
              :clearable="true"
            >
              <el-option
                v-for="(value, key) in statusOptions"
                :key="key"
                :label="value"
                :value="parseInt(key)"
              ></el-option>
            </el-select>
          </el-form-item> -->
        </el-form>
        <div class="mt-10">
          <el-button
            type="primary"
            size="small"
            @click="requestProductPromotions()"
            >筛选</el-button
          >
          <el-button size="small" @click="reset()">重置</el-button>
        </div>
      </div>
    </div>
    <div class="panel mt-20">
      <div class="header flex-row-between" v-if="type == 3">
        <el-button
          type="primary"
          icon="el-icon-plus"
          size="small"
          @click="startProductPromotion"
          v-permission="Auth.productPromotionCreate"
          >发布促销</el-button
        >
        <file-button
          v-permission="Auth.productPromotionIE"
          obj="product_promotion"
          class="mobile-hide"
          :filter="{}"
          :exportButton="false"
          @importCallback="importCallback"
        ></file-button>
      </div>

      <el-table v-if="!isMobile()" :data="promotions" v-loading="loading">
        <el-table-column label="产品信息" prop="material_desc">
          <template slot-scope="scope">
            <div>件号：{{ scope.row.material }}</div>
            <div>{{ scope.row.material_desc }}</div>
            <!-- <div class="text-danger" v-if="scope.row.remark">
              {{ scope.row.remark }}
            </div> -->
          </template>
        </el-table-column>
        <el-table-column
          label="促销价"
          prop="promotion_price"
          align="center"
          width="200px"
        >
          <template slot-scope="scope">
            ￥{{ math.show(scope.row.promotion_price) }}
            <del class="text-gray">￥{{ math.show(scope.row.price) }}</del>
          </template>
        </el-table-column>
        <el-table-column label="促销时间" align="center" width="220px">
          <template slot-scope="scope">
            {{ formatTime(scope.row.start_date) }}
            至
            {{ formatTime(scope.row.end_date) }}
          </template>
        </el-table-column>
        <el-table-column
          label="促销总量"
          align="center"
          width="150px"
          prop="total_quantity"
        >
          <template slot-scope="scope">
            {{
              scope.row.total_quantity == 0 ? '不限' : scope.row.total_quantity
            }}
          </template>
        </el-table-column>
        <el-table-column
          label="剩余数量"
          align="center"
          width="150px"
          prop="left_quantity"
        >
          <template slot-scope="scope">
            {{
              scope.row.total_quantity == 0 ? '不限' : scope.row.left_quantity
            }}
          </template>
        </el-table-column>
        <el-table-column label="状态" width="116px" align="center">
          <template slot-scope="scope">
            <status-tag
              :name="statusShow(scope.row).name"
              :type="statusShow(scope.row).type"
            >
            </status-tag>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="操作"
          width="210px"
          v-if="auth.isPlatformUser() && this.type == 3"
          ><template slot-scope="scope">
            <el-button
              type="primary"
              size="mini"
              v-if="scope.row.status != 2"
              v-permission="Auth.productPromotionUpdate"
              @click="startProductPromotion(scope.row, scope.$index)"
              plain
              >编辑</el-button
            >
            <el-button
              type="info"
              size="mini"
              v-if="scope.row.status == 1"
              v-permission="Auth.productPromotionManage"
              plain
              @click="handleProductPromotion(scope.$index, 99)"
              >关闭</el-button
            >
            <el-button
              type="primary"
              size="mini"
              v-if="scope.row.status == 1"
              v-permission="Auth.productPromotionManage"
              @click="handleProductPromotion(scope.$index, 2)"
              >发布</el-button
            >
            <el-button
              type="danger"
              size="mini"
              v-if="scope.row.status == 2"
              v-permission="Auth.productPromotionManage"
              @click="handleProductPromotion(scope.$index, 1)"
              >撤回</el-button
            >
          </template></el-table-column
        ></el-table
      >
      <ul v-else class="list-style">
        <li v-for="(item, index) in promotions">
          <div class="flex-row-between">
            <div>
              <div>{{ item.material_desc }}</div>
              <div class="font-12" v-if="item.material">
                件号：{{ item.material }}
              </div>
              <div class="font-12">
                促销时间：{{ formatTime(item.start_date) }}至{{
                  formatTime(item.end_date)
                }}
              </div>
              <div class="font-12">
                促销总量：{{
                  item.total_quantity == 0 ? '不限' : item.total_quantity
                }}
              </div>
              <div class="font-12">
                剩余数量：{{
                  item.total_quantity == 0 ? '不限' : item.left_quantity
                }}
              </div>
              <div class="font-12 text-danger" v-if="item.remark">
                备注：{{ item.remark }}
              </div>
            </div>
            <div style="text-align: right; line-height: 1">
              <div class="text-primary" style="font-size: 14px">
                ￥{{ math.show(item.promotion_price) }}
              </div>
              <del class="text-info-12">￥{{ math.show(item.price) }}</del>
            </div>
          </div>
          <div>
            <div class="flex-row-between mt-10">
              <status-tag
                class="font-12"
                v-if="auth.isPlatformUser()"
                :name="statusShow(item).name"
                :type="statusShow(item).type"
              >
              </status-tag>
              <div>
                <template v-if="auth.isPlatformUser() && type == 3">
                  <el-button
                    type="primary"
                    size="mini"
                    v-if="item.status != 2"
                    v-permission="Auth.productPromotionUpdate"
                    @click="startProductPromotion(item, index)"
                    plain
                    >编辑</el-button
                  >
                  <el-button
                    type="info"
                    size="mini"
                    v-if="item.status == 1"
                    v-permission="Auth.productPromotionManage"
                    plain
                    @click="handleProductPromotion(index, 99)"
                    >关闭</el-button
                  >
                  <el-button
                    type="primary"
                    size="mini"
                    v-if="item.status == 1"
                    v-permission="Auth.productPromotionManage"
                    @click="handleProductPromotion(index, 2)"
                    >发布</el-button
                  >
                  <el-button
                    type="danger"
                    size="mini"
                    v-if="item.status == 2"
                    v-permission="Auth.productPromotionManage"
                    @click="handleProductPromotion(index, 1)"
                    >撤回</el-button
                  >
                </template>
              </div>
            </div>
          </div>
        </li>
      </ul>
      <div class="mt-20">
        <el-pagination
          class="mt-20"
          :page-size="filter.size"
          :current-page.sync="filter.page"
          layout="total, prev, pager, next"
          :total="total"
        ></el-pagination>
      </div>
    </div>
    <promotion-former
      :model="formerModel"
      :show.sync="formerVisible"
      @created="createdProductPromotion"
      @updated="updatedProductPromotion"
    ></promotion-former>
  </div>
</template>

<script>
import PromotionFormer from './former'
import { isMobile, formatTime, clone } from '@/util/index'
import {
  deleteProductPromotion,
  productPromotionList,
  deviceQuestHandle,
  deviceQuestList,
  changeProductPromotionStatus,
} from '../../service/getData'
import auth from '../../util/auth'
import { ProductPromotionStatusMap } from '../../config/global'
import store from '@/store/store'
import math from '../../util/math'

export default {
  components: { PromotionFormer },
  props: {
    type: {
      type: Number,
      default: 3,
    },
  },
  data() {
    return {
      promotions: [],
      auth,
      math,
      isMobile,
      formatTime,
      loading: false,
      formerVisible: false,
      userInfo: store.getters.userInfo,
      formerModel: {},
      submiting: false,
      manageVisible: false,
      ProductPromotionStatusMap,
      editIndex: -1,
      total: 0,
      filter: {
        query: '',
        page: 1,
        status: null,
        size: 20,
      },
    }
  },
  watch: {
    'filter.page': function () {
      this.requestProductPromotions()
    },
  },
  computed: {
    statusOptions() {
      if (this.type == 3) {
        return {
          1: '未发布',
          2: '进行中',
          3: '已发布未开始',
        }
      }
    },
  },
  created() {
    this.filter = {
      query: this.$route.query.query || '',
      status: parseInt(this.$route.query.status) || null,
      page: parseInt(this.$route.query.page || 1),
      size: parseInt(this.$route.query.size || 20),
    }
    this.requestProductPromotions()
  },
  methods: {
    async requestProductPromotions() {
      this.$router.replace({
        query: this.filter,
      })

      this.loading = true
      let data = clone(this.filter)
      data.page = data.page - 1

      data.status = data.status || 0
      data.type = this.type
      let res = await productPromotionList(data)
      if (res.code == 0) {
        this.promotions = res.data.list
        this.total = res.data.total
      }
      this.loading = false
    },
    createdProductPromotion(d) {
      this.promotions.unshift(d)
    },
    updatedProductPromotion(d) {
      if (this.editIndex >= 0) {
        this.promotions.splice(this.editIndex, 1, d)
      }
    },
    statusShow(p) {
      let name = ''
      let type = ''
      let now = new Date().getTime()
      let start = new Date(p.start_date).getTime()
      let end = new Date(p.end_date).getTime()
      if (p.status == 1) {
        name = '未发布'
        type = 'primary'
      } else if (p.status == 2 && now < start) {
        name = '已发布未开始'
        type = 'warning'
      } else if (p.status == 2 && now >= start && now < end) {
        name = '进行中'
        type = 'success'
      } else if (p.status == 99) {
        name = '已关闭'
        type = 'info'
      } else {
        name = '已结束'
        type = 'success'
      }
      return {
        name: name,
        type: type,
      }
    },
    handleProductPromotion(index, status) {
      let promotion = this.promotions[index]
      let title = ''
      let msg = ''
      if (status == 2) {
        title = '是否确认发布此促销？'
        msg = '将会通知所有激活的中间商。'
      } else if (status == 1) {
        title = '是否确认撤回此促销？'
      } else if (status == 99) {
        title = '是否确认关闭此促销？'
      } else {
        return
      }
      this.$confirm(msg, title).then(() => {
        let that = this
        this.submiting = true
        let data = {
          id: promotion.id,
          status: status,
        }
        changeProductPromotionStatus(data).then((res) => {
          if (res.code == 0) {
            if (res.data.status == 99) {
              that.promotions.splice(index, 1)
            } else {
              that.promotions.splice(index, 1, res.data)
            }
            that.$message.success('操作成功！')
          }
          that.submiting = false
        })
      })
    },
    reset() {
      this.filter = {
        query: '',
        page: 1,
        size: 20,
      }
      this.requestProductPromotions()
    },
    startProductPromotion(model, index) {
      if (model.id > 0) {
        this.editIndex = index
        this.formerModel = clone(model)
        this.formerModel.dates = [
          formatTime(this.formerModel.start_date),
          formatTime(this.formerModel.end_date),
        ]
      } else {
        this.formerModel = {
          commodity_id: '',
          material_desc: '',
          material: '',
          total_quantity: 0,
          buy_quantity: 0,
          remark: '',
          price: '',
          promotion_price: '',
          dates: null,
        }
      }

      this.formerVisible = true
    },
    importCallback(res) {
      if (res.code == 0) {
        this.reset()
      }
      s
    },
  },
}
</script>